<template>
  <svg :width="width" :height="height" viewBox="0 0 256 227" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid">
	<g>
		<path d="M0.832426495,0.4518607 L255.680619,0.4518607 L255.680619,226.093573 L0.832426495,226.093573 L0.832426495,0.4518607 L0.832426495,0.4518607 Z" fill="#E6E6E1"></path>
		<path d="M255.680619,0.4518607 L0.832426495,0.4518607 L128.263888,186.691044 L255.680619,0.4518607" fill="#D8D8D3"></path>
		<path d="M101.299301,226.093573 L155.225528,226.093573 L128.263888,186.691044 L101.299301,226.093573" fill="#B4B6B4"></path>
		<path d="M128.302186,118.827369 L73.9399525,39.0383522 L73.9399525,107.529522 L104.98178,153.124508 L128.249158,118.895126 L128.302186,118.827369" fill="#1A1918"></path>
		<path d="M128.302186,118.827369 L151.713917,153.198158 L182.558363,108.101043 L182.558363,39.0383522 L128.302186,118.827369" fill="#ED9D4A"></path>
		<path d="M128.249158,118.895126 L104.98178,153.124508 L128.325754,187.39808 L151.713917,153.198158 L128.302186,118.827369 L128.249158,118.895126" fill="#BB7731"></path>
		<path d="M35.332839,187.489406 L73.9399525,187.489406 L73.9399525,107.529522 L35.332839,50.8605839 L35.332839,187.489406" fill="#4CB2D4"></path>
		<path d="M35.332839,39.0383522 L35.332839,50.8605839 L73.9399525,107.529522 L73.9399525,39.0383522 L35.332839,39.0383522" fill="#1B82AD"></path>
		<path d="M182.558363,108.101043 L182.558363,187.489406 L221.150747,187.489406 L221.150747,51.6825133 L182.558363,108.101043" fill="#C02439"></path>
		<path d="M221.150747,39.0383522 L182.558363,39.0383522 L182.558363,108.101043 L221.150747,51.6825133 L221.150747,39.0383522" fill="#8F202F"></path>
	</g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'MandrillLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
